import { render, staticRenderFns } from "./ProjectStatusListFilters.vue?vue&type=template&id=b83bb08a"
import script from "./ProjectStatusListFilters.vue?vue&type=script&lang=js"
export * from "./ProjectStatusListFilters.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatusListFilters.vue?vue&type=style&index=0&id=b83bb08a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports